import React from 'react'

import DatePicker from 'react-16-bootstrap-date-picker'
import moment from 'moment'

export class PurchaseVoucherDate extends React.Component {

  constructor(props) {
    super(props)
    this.handleChange = this.handleChange.bind(this)
  }

  handleChange(value) {
    let s = moment(value).format('YYYY-MM-DD') + "T" + moment().format('HH:mm:ss')
    this.props.handleDateChange(s)
  }

  render() {
      let inputValue
      if(typeof this.props.purchase !== "undefined" && typeof this.props.purchase.voucher_date !== "undefined") {
        inputValue = this.props.purchase.voucher_date
      }
      else {
        inputValue = moment().format()
      }

    return <DatePicker value={inputValue} onChange={this.handleChange} dateFormat="DD-MM-YYYY" showClearButton={false} />
  }
  
}

export default class PurchaseDate extends React.Component {

  constructor(props) {
    super(props)
    this.handleChange = this.handleChange.bind(this)
  }

  handleChange(value) {
    let s = moment(value).format('YYYY-MM-DD') + "T" + moment().format('HH:mm:ss')
    this.props.handleDateChange(s)
  }

  render() {
      let inputValue
      if(typeof this.props.purchase !== "undefined" && typeof this.props.purchase.date !== "undefined") {
        inputValue = this.props.purchase.date
      }
      else {
        inputValue = moment().format()
      }

    return <DatePicker value={inputValue} onChange={this.handleChange} dateFormat="DD-MM-YYYY" showClearButton={false} />
  }
}



// WEBPACK FOOTER //
// ./src/components/purchase/rowelements/purchasedate.js